export default __webpack_public_path__ + "static/media/icon_arrow_down.6b6d5c49.svg";